import { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import axios from "axios";
import API_ENDPOINTS from "config/api";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";
import ReportsBarChart from "examples/Charts/BarCharts/ReportsBarChart";
import ReportsLineChart from "examples/Charts/LineCharts/ReportsLineChart";

// Dashboard components
import ProductosStockBajo from "./ProductosStockBajo";
import MovimientosRecientes from "./MovimientosRecientes";
import ValorInventarioPorAlmacen from "./ValorInventarioPorAlmacen";

export default function DashboardInventario() {
  const [estadisticas, setEstadisticas] = useState({
    totalProductos: 0,
    totalValor: 0,
    productosStockBajo: 0,
    movimientosHoy: 0,
  });

  const [movimientosChart, setMovimientosChart] = useState({
    labels: [],
    datasets: { label: "Movimientos", data: [] },
  });

  const [valorPorCategoriaChart, setValorPorCategoriaChart] = useState({
    labels: [],
    datasets: { label: "Valor", data: [] },
  });

  const empresaId = localStorage.getItem("empresaId");

  useEffect(() => {
    fetchEstadisticas();
    fetchMovimientosChart();
    fetchValorPorCategoria();
  }, [empresaId]);

  const fetchEstadisticas = async () => {
    try {
      const response = await axios.get(API_ENDPOINTS.INVENTARIO.ESTADISTICAS, {
        params: { empresa_id: empresaId },
      });
      setEstadisticas(
        response.data || {
          totalProductos: 0,
          totalValor: 0,
          productosStockBajo: 0,
          movimientosHoy: 0,
        }
      );
    } catch (error) {
      console.error("Error al obtener estadísticas:", error);
      setEstadisticas({
        totalProductos: 0,
        totalValor: 0,
        productosStockBajo: 0,
        movimientosHoy: 0,
      });
    }
  };

  const fetchMovimientosChart = async () => {
    try {
      const response = await axios.get(API_ENDPOINTS.INVENTARIO.MOVIMIENTOS_CHART, {
        params: { empresa_id: empresaId },
      });
      setMovimientosChart(
        response.data || { labels: [], datasets: { label: "Movimientos", data: [] } }
      );
    } catch (error) {
      console.error("Error al obtener datos de movimientos:", error);
      setMovimientosChart({ labels: [], datasets: { label: "Movimientos", data: [] } });
    }
  };

  const fetchValorPorCategoria = async () => {
    try {
      const response = await axios.get(API_ENDPOINTS.INVENTARIO.VALOR_CATEGORIA, {
        params: { empresa_id: empresaId },
      });
      setValorPorCategoriaChart(
        response.data || { labels: [], datasets: { label: "Valor", data: [] } }
      );
    } catch (error) {
      console.error("Error al obtener valor por categoría:", error);
      setValorPorCategoriaChart({ labels: [], datasets: { label: "Valor", data: [] } });
    }
  };

  return (
    <MDBox py={3}>
      <Grid container spacing={3}>
        {/* Tarjetas de Estadísticas */}
        <Grid item xs={12} md={6} lg={3}>
          <MDBox mb={1.5}>
            <ComplexStatisticsCard
              color="dark"
              icon="inventory_2"
              title="Total Productos"
              count={estadisticas.totalProductos || 0}
              percentage={{
                color: "success",
                amount: "+12%",
                label: "vs mes anterior",
              }}
            />
          </MDBox>
        </Grid>
        <Grid item xs={12} md={6} lg={3}>
          <MDBox mb={1.5}>
            <ComplexStatisticsCard
              icon="attach_money"
              title="Valor Total Inventario"
              count={`$${(estadisticas.totalValor || 0).toLocaleString()}`}
              percentage={{
                color: "success",
                amount: "+8%",
                label: "vs mes anterior",
              }}
            />
          </MDBox>
        </Grid>
        <Grid item xs={12} md={6} lg={3}>
          <MDBox mb={1.5}>
            <ComplexStatisticsCard
              color="warning"
              icon="warning"
              title="Stock Bajo"
              count={estadisticas.productosStockBajo || 0}
              percentage={{
                color: "warning",
                amount: "Requiere atención",
                label: "productos",
              }}
            />
          </MDBox>
        </Grid>
        <Grid item xs={12} md={6} lg={3}>
          <MDBox mb={1.5}>
            <ComplexStatisticsCard
              color="primary"
              icon="swap_horiz"
              title="Movimientos Hoy"
              count={estadisticas.movimientosHoy || 0}
              percentage={{
                color: "success",
                amount: "+15%",
                label: "vs ayer",
              }}
            />
          </MDBox>
        </Grid>

        {/* Gráficos */}
        <Grid item xs={12} md={6} lg={8}>
          <ReportsBarChart
            color="info"
            title="Movimientos de Inventario"
            description="Últimos 7 días"
            date="actualizado hace 2 minutos"
            chart={movimientosChart}
          />
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <ReportsLineChart
            color="success"
            title="Valor por Categoría"
            description={
              <>
                (<strong>+15%</strong>) incremento este mes.
              </>
            }
            date="actualizado ahora"
            chart={valorPorCategoriaChart}
          />
        </Grid>

        {/* Tablas de Detalle */}
        <Grid item xs={12} md={6} lg={4}>
          <ProductosStockBajo />
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <MovimientosRecientes />
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <ValorInventarioPorAlmacen />
        </Grid>
      </Grid>
    </MDBox>
  );
}
